import * as React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../shared/LanguageService';

type BookingsCalendarHeaderLabels = {
    pageTitle: string;
};

type ExternalProps = {
    numberOfOrders: number;
};

type BookingsCalendarHeadingProps = {
    labels: BookingsCalendarHeaderLabels;
} & ExternalProps;

let StyledPageTitle = styled(Typography)(({ theme }) => ({
    fontSize: '20px',
    lineHeight: '32px',
    fontWeight: 500
}));

function UnbookedOrdersPageHeading({ labels, numberOfOrders }: BookingsCalendarHeadingProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <StyledPageTitle variant={'h1'}>{labels.pageTitle} </StyledPageTitle>
            <Chip
                sx={{
                    backgroundColor: '#333D45',
                    borderRadius: '16px',
                    minWidth: '36px',
                    height: '24px',
                    color: 'white',
                    margin: '5px',
                    overflow: 'visible'
                }}
                label={numberOfOrders}
            />
        </Box>
    );
}

const UnbookedOrdersPageHeadingTranslationLayer = (props: ExternalProps) => {
    let labels: BookingsCalendarHeaderLabels = {
        pageTitle: Translate('orders/list/bookings-calendar/page-title')
    };

    return <UnbookedOrdersPageHeading labels={labels} {...props} />;
};

export default UnbookedOrdersPageHeadingTranslationLayer;
